// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { applicationLifecycleManifest } from './application-lifecycle';
import { businessAnalysisManifest } from './business-analysis';
import { implementationAssistanceManifest } from './implementation-assistance';
import { informationModelsManifest } from './information-models';
import { visualStudioCodeExtensionsManifest } from './visual-studio-code-extensions';

/** Група модулів «Мета» (Meta): 5 модулів. */
export const metaGroup: IModuleGroupManifest = {
  key: 'meta',
  category: 'Meta',
  name: { en: 'Meta', uk: 'Мета' },
  sort: 20,
  modules: [applicationLifecycleManifest, businessAnalysisManifest, implementationAssistanceManifest, informationModelsManifest, visualStudioCodeExtensionsManifest],
};
